<template>
    <div class="dashboard-charts">
        <h2 class="heading">{{ graphHeading }}</h2>
        <base-table-spinner v-show="showSpinner"></base-table-spinner>
        <div v-show="!noRecordFound && !showSpinner" class="donut-graph">
            <div :id="id + 1" class="pie-chart-inner-table">
                <div
                    :id="id"
                    class="amcharts-div pie-charts screening-by-type"
                ></div>
                <div class="chart-highest-record">
                    <h2>HIGHEST</h2>
                    <p v-if="maximum && maximum.group">
                        {{ maximum.group | capitalize }}
                        <strong>{{ maximum ? maximum.count : '' }}</strong>
                        {{ maximum ? '(' + maximum.percentage + ')' : '' }}
                    </p>
                </div>
            </div>
            <div id="style-2" class="scrollable more-legends">
                <div
                    :id="legendId"
                    class="custom-legend-wrapper cols-3 mob-cols-2"
                ></div>
            </div>
        </div>
        <base-no-record-found v-show="noRecordFound"></base-no-record-found>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import resource from '@/api/resource'
import _ from 'lodash'
export default {
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        id: {
            type: String,
            default: null,
        },
        legendId: {
            type: String,
            default: null,
        },
        path: {
            type: String,
            required: true,
        },
        query: {
            type: Object,
            required: true,
        },
        reset: {
            type: Number,
            default: new Date().getTime(),
        },
        graphHeading: {
            type: String,
            required: true,
        },
    }, // End of Component > props
    data() {
        return {
            dataProvider: [],
            valueField: null,
            titleField: null,
            percents: null,

            resourceApi: null,
            noRecordFound: false,
            showSpinner: true,
        }
    },

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['dataSegmentId']),
        maximum() {
            return _.maxBy(this.dataProvider, 'count')
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        reset(value) {
            if (value) {
                this.getStats()
            }
        },
        dataSegmentId(value) {
            if (value) {
                this.noRecordFound = false
                this.showSpinner = true
                this.getStats()
            }
        },
    }, // End of Component > watch

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        this.getStats()
    }, // End of Component > mounted
    /*
    |--------------------------------------------------------------------------
    | Component > created
    |--------------------------------------------------------------------------
    */
    created() {
        this.resourceApi = new resource(this.path)
    }, // End of Component > computed
    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        created() {
            let self = this
            window.AmCharts.makeChart(self.id, {
                type: 'pie',
                innerRadius: '80%',
                colors: [
                    '#7f1ec5',
                    '#00a4f2',
                    '#00c535',
                    '#eb8300',
                    '#f4c200',
                    '#c1c1c1',
                    '#990000',
                    '#ff87e6',
                ],
                labelsEnabled: false,
                pullOutRadius: '0%',
                // balloonText: '[[group]]: <b>[[value]]</b> [[percents]]%',
                balloonFunction: function(graph) {
                    var category = graph.dataContext.group
                    if (self.id !== 'customer-by-age') {
                        category = _.startCase(category)
                    }

                    return (
                        category +
                        ': <b>' +
                        graph.value +
                        '</b> ' +
                        graph.dataContext.percentage
                    )
                },
                marginBottom: 0,
                marginTop: 0,
                outlineAlpha: 1,
                outlineThickness: 2,
                titleField: this.titleField,
                valueField: this.valueField,
                color: '#1B1B1E',
                fontFamily: 'ProximanovaRegular',
                fontSize: 14,
                allLabels: [],
                customLabels: '<b>[[value]]</b> [[percents]]%',
                balloon: {
                    color: '#1B1B1E',
                    fillAlpha: 1,
                },
                legend: {
                    enabled: false,
                    align: 'center',
                    markerBorderAlpha: 0.27,
                    markerBorderThickness: 0,
                    markerCorner: 12,
                    markerLabelGap: 12,
                    markerSize: 20,
                    spacing: 8,
                    labelText: '[[group]]',
                    valueText: '[[percents]]%',
                    verticalGap: 20,
                },
                titles: [],
                dataProvider: this.dataProvider,
                export: {
                    enabled: true,
                    libs: { path: '../libs/amcharts' },
                    menu: [],
                },
                listeners: [
                    {
                        event: 'init',
                        method: function(event) {
                            // chart initialized
                            // let's build a custom legend
                            var chart = event.chart

                            // get legend object

                            var legend = document.getElementById(self.legendId)
                            document.getElementById(self.legendId).innerHTML =
                                ''
                            if (self.id == 'customer-by-age') {
                                chart.dataProvider = _.sortBy(
                                    chart.dataProvider,
                                    [
                                        function(o) {
                                            return o.group
                                        },
                                    ]
                                )
                            }
                            // cycle through the data
                            for (
                                var i = 0;
                                i < chart.dataProvider.length;
                                i++
                            ) {
                                // data point
                                var dp = chart.dataProvider[i]
                                // create a legend item holder
                                var item = document.createElement('div')

                                // create marker
                                var marker = document.createElement('div')
                                marker.className = 'legend-marker'
                                marker.style.backgroundColor = chart.colors[i]
                                item.appendChild(marker)

                                // create title
                                var title = document.createElement('div')
                                title.className = 'legend-title'
                                title.innerHTML = dp.group
                                if (self.id != 'customer-by-age') {
                                    title.innerHTML = _.startCase(dp.group)
                                }

                                item.appendChild(title)
                                // create absolute value
                                var value = document.createElement('div')
                                value.className = 'legend-value'
                                value.innerHTML = dp.percentage
                                item.appendChild(value)

                                // add item to legend
                                legend.appendChild(item)
                            }
                        },
                    },
                ],
            })
        },
        async getStats() {
            try {
                this.dataProvider = []
                this.query.dataSegmentId = this.dataSegmentId
                    ? this.dataSegmentId
                    : localStorage.getItem('activeDataSegmentId')
                let { data } = await this.resourceApi.list(this.query)
                this.showSpinner = false
                if (data && data.data) {
                    if (data.data.length) {
                        this.titleField = 'type'
                        this.valueField = 'count'
                        this.percents = 'percentage'
                        this.dataProvider = data.data
                    } else {
                        this.noRecordFound = true
                    }
                } else {
                    this.noRecordFound = true
                }
                this.created()
            } catch (error) {
                this.$store.commit('setError', error)
            }
        },
    }, // End of Component > created
} // End of export default
</script>
